import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/resources/llantas-cavazos-shopify-migration-case-study")({
  beforeLoad: () => {
    throw redirect({ to: "/resources/llantas-cavazos-migration-case-study", statusCode: 301 });
  },
});
